import classDetailMessages from '@/containers/classPages/ClassDetailPage/ClassDetailPage.messages';
import { messages as classNotesMessages } from '@/containers/classPages/ClassNotesPage/index.messages';
import labPageMessages from '@/containers/labPage/Lab.messages';
import { paths } from '@/routing/paths';
import {
    classDetailPageBreadcrumb,
    classesPageBreadcrumb,
    classPageBreadcrumb,
    classNotesPageBreadcrumb,
} from '@/utils/breadcrumbs';
import type { DecodedAppParams } from '@/utils/paramHooks';

import type { BreadcrumbGroupProps } from '@amzn/awsui-components-console';
import type { MessageDescriptor } from 'react-intl';

export type PageId = 'dayOf' | 'detail' | 'lab' | 'attendance' | 'notes';

export const getPageId = (pathname: string, params: DecodedAppParams): PageId => {
    const classroomId = params.classroomId as string;
    const labNumber = params.labNumber as number;
    switch (pathname) {
        case paths.classPageV1(classroomId):
        case paths.classPage(classroomId):
            return 'dayOf';
        case paths.classDetailPageV1(classroomId):
        case paths.classDetailPage(classroomId):
            return 'detail';
        case paths.labPageV1(classroomId, labNumber):
        case paths.labPage(classroomId, labNumber):
            return 'lab';
        case paths.classNotesPage(classroomId):
            return 'notes';
        default:
            return 'detail';
    }
};

type PageMetadata = {
    title: string;
    breadcrumbs: BreadcrumbGroupProps['items'];
};
export const getPageMetadata = ({
    pageId,
    classroomId,
    courseTitle,
    formatMessage,
}: Pick<DecodedAppParams, 'classroomId'> & {
    pageId: PageId;
    courseTitle: string;
    formatMessage: (msg: MessageDescriptor) => string;
}): PageMetadata => {
    switch (pageId) {
        case 'dayOf':
            return {
                breadcrumbs: [
                    classesPageBreadcrumb(formatMessage),
                    classPageBreadcrumb(formatMessage, classroomId),
                ],
                title: courseTitle,
            };
        case 'lab':
            return {
                breadcrumbs: [
                    classesPageBreadcrumb(formatMessage),
                    { text: formatMessage(labPageMessages.sectionTitle), href: '' },
                ],
                title: formatMessage(labPageMessages.pageTitle),
            };
        case 'notes':
            return {
                title: formatMessage(classNotesMessages.pageTitle),
                breadcrumbs: [
                    classesPageBreadcrumb(formatMessage),
                    classNotesPageBreadcrumb(formatMessage, classroomId),
                ],
            };
        case 'detail':
        default:
            return {
                title: formatMessage(classDetailMessages.pageTitle),
                breadcrumbs: [
                    classesPageBreadcrumb(formatMessage),
                    classDetailPageBreadcrumb(formatMessage, classroomId),
                ],
            };
    }
};
